import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ModalComponent } from '../../../modal/modal.component';
import { ConfirmComponent } from '../../../modal/confirm.component';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { InstallationJobProducedPluginService } from './job-produced.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
    templateUrl: './job-produced-edit.component.html',
    standalone: false
})
export class InstallationJobProducedEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;

  public labelValues: any[];
  public itemToRemove: any;
  public currentItem: any;

  private sub = new Subscription();

  @ViewChild('labelValuesModal', { static: true }) labelValuesModal: ModalComponent;
  @ViewChild('labelValueDeleteConfirm', { static: true }) labelValueDeleteConfirm: ConfirmComponent;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationJobProducedPluginService,
    private fb: UntypedFormBuilder
  ) {
    super(location, pluginService, activatedRoute, router);
    this.labelValues = pluginService.getLabelValues();
  }

  get formlabelValues() {
    return <UntypedFormArray>this.editForm.controls['labelValues'];
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updateJobProduced(this.inspectionId, this.pointId, this.pluginId, model).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public add() {
    const control = <UntypedFormArray>this.editForm.controls['labelValues'];
    control.push(this.initLabelValue());
  }

  public onClose(e: any) {
    this.editForm.controls['labelValues'].markAsTouched();
  }

  public selectLabelValuesMenu(item: any) {
    const selectedIndex = this.currentItem.controls['label'].value === item.selectedIndex ? '' : item.selectedIndex;
    this.currentItem.controls['label'].setValue(selectedIndex);
  }

  public openLabelValuesSelector(selectedIndex: number, i: number): void {
    this.openSelector(
      this.labelValuesModal,
      this.labelValues,
      selectedIndex || selectedIndex === 0 ? selectedIndex : -1
    );
    const control = <UntypedFormArray>this.editForm.controls['labelValues'];
    this.currentItem = control.controls[i];
  }

  public remove(e: any) {
    const control = <UntypedFormArray>this.editForm.controls['labelValues'];
    control.removeAt(this.itemToRemove);
  }

  public openLabelValuesDeleteConfirm(i: number) {
    this.labelValueDeleteConfirm.open();
    this.itemToRemove = i;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.labelValues = this.pluginService.getLabelValues();
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = new UntypedFormGroup({
      jobName: new UntypedFormControl(
        this.plugin.config.JobProduced?.JobName ? this.plugin.config.JobProduced?.JobName : ''
      ),
      sheetSize: new UntypedFormControl(
        this.plugin.config.JobProduced?.SheetSize ? this.plugin.config.JobProduced?.SheetSize : ''
      ),
      productionSpeed: new UntypedFormControl(
        this.plugin.config.JobProduced?.ProductionSpeed ? this.plugin.config.JobProduced?.ProductionSpeed : ''
      ),
      labelValues: new UntypedFormArray([]),
      comment: new UntypedFormControl(
        this.plugin.config.JobProduced?.Comment ? this.plugin.config.JobProduced?.Comment : ''
      )
    });

    const control = <UntypedFormArray>this.editForm.controls['labelValues'];
    _.forEach(this.plugin.config.JobProduced?.LabelValues, (el) => {
      control.push(this.initLabelValue(el));
    });
  }

  private initLabelValue(el?: any) {
    return this.fb.group({
      label: new UntypedFormControl(el && el.Label ? el.Label : ''),
      value: new UntypedFormControl(el && el.Value ? el.Value : '')
    });
  }

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '20rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    toolbarHiddenButtons: [
      [
        'undo',
        'redo',
        'underline',
        'strikeThrough',
        'subscript',
        'superscript',
        'justifyLeft',
        'justifyCenter',
        'justifyRight',
        'justifyFull',
        'indent',
        'outdent',
        'customClasses',
        'link',
        'unlink',
        'insertImage',
        'insertVideo',
        'heading',
        'fontName',
        'fontSize',
        'textColor',
        'backgroundColor',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode'
      ]
    ]
  };
}
